// Single source of truth for which file types the document upload endpoints accept.
// Used to drive both the file-input `accept` attribute and drag-and-drop validation
// so the two can't drift apart.
export const SUPPORTED_DOCUMENT_EXTENSIONS = [".pdf", ".docx", ".doc"] as const;

export const DOCUMENT_ACCEPT_ATTR = SUPPORTED_DOCUMENT_EXTENSIONS.join(",");

export function isSupportedDocumentFile(filename: string): boolean {
  const dot = filename.lastIndexOf(".");
  if (dot <= 0) return false;
  const extension = filename.slice(dot).toLowerCase();
  return SUPPORTED_DOCUMENT_EXTENSIONS.some((ext) => ext === extension);
}
